/*
  Zugo - kategori sayfasindaki marka logolarini filtre dugmesine cevirir.

  Logolar zaten gercek baglanti (`url_to_add` / `url_to_remove`), yani JS
  yuklenmese de calisirlar - tiklayinca sayfa yenilenir ve filtre uygulanir.
  Buradaki is yalnizca hizlandirmak: sayfa yenilemek yerine temanin kendi
  filtre formundaki ilgili kutuyu isaretleyip AJAX guncellemesini tetikler.

  Tema kutusu bulunamazsa hicbir sey yapmaz; tarayici baglantiyi normal
  sekilde izler. Bozulan bir sey olmaz.
*/
class ZugoMarkaFiltre extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => this.tiklandi(e));
  }

  tiklandi(e) {
    const oge = e.target.closest('.zugo-marka-serit__oge');
    if (!oge) return;

    const kutu = this.temaKutusu(oge.dataset.marka);
    if (!kutu) return; // tema filtresi yok - normal baglanti calissin

    e.preventDefault();

    // Gorsel geri bildirim hemen verilir; sayfa tazelendiginde sunucudan
    // gelen isaret zaten dogru olacak.
    const secilecek = oge.getAttribute('aria-pressed') !== 'true';
    oge.setAttribute('aria-pressed', secilecek ? 'true' : 'false');
    oge.classList.toggle('is-secili', secilecek);

    kutu.checked = secilecek;
    kutu.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Filtre panelindeki marka kutusunu deger uzerinden bulur. Tema kutuyu
     `name="filter.p.vendor"` ile isaretliyor; deger tam marka adi. */
  temaKutusu(marka) {
    if (!marka) return null;
    const hepsi = document.querySelectorAll('input[name="filter.p.vendor"]');
    for (const k of hepsi) {
      if (k.value === marka) return k;
    }
    return null;
  }
}

if (!customElements.get('zugo-marka-filtre')) {
  customElements.define('zugo-marka-filtre', ZugoMarkaFiltre);
}
